import { Component, OnInit, Input } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';
import { Iaddress } from 'my-lib-sanfelici/my-lib-sanfelici';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent implements OnInit {
  @Input() address: Iaddress;
  constructor(public dialog: MatDialog) { }
  openDialog(): void {
    const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {

    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
      if (result) {
        this.address = result;
        console.log(this.address);
      }
    });
  }
  ngOnInit() {
    if (this.address){

    } else {
      this.address = {country: null,
      route: null,
    postal_code: null,
    administrative_area_level_1: null,
    administrative_area_level_2: null,
    administrative_area_level_3: null,
    street_number: null,
    latitude: null,
    longitude: null
    }
    }
  }

}
